import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // 🔥 SCROLL TO SECTION (HOME PAGE)
  const handleScroll = (id) => {
    setOpen(false);

    // go to home first
    navigate("/");

    // delay scroll (wait for page render)
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* LEFT */}
        <div className="nav-left">
          <Link to="/">
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCupZUh3oen9SrmBCKjt3OmRTfO9_P0qW5hBmgorgZjw4RASu-mzu5X7kOfSVoKkLFiIuXIlInLeM0Ln108lXco878yzUPJcCP-ZzybUmTjyouKp1hP8CDP4BSCoOms8Hqj4CAlvUr65q75Ybf0LQP-QtXQ_ObNNMAzuhe3DUy7ULpc2ggMriaNl5uNkVtPjDIROeH64WPZ65oek1Syl6imhos9hPo9dxPoZxYzErmQrKiJYyr5TMU19B1qkDuDZl5G1hBmzRYhSNmQ"
              className="nav-img"
              alt="logo"
            />
          </Link>
        </div>

        {/* CENTER */}
        <div className="nav-center">
          <span className="nav-name">
            Prof. Dr. K. M. Diwakarrao
          </span>
        </div>

        {/* RIGHT */}
        <div className="nav-right">

          <ul className={`nav-links ${open ? "active" : ""}`}>

            {/* SCROLL LINKS */}
            <li onClick={() => handleScroll("bio")}>Biography</li>
            <li onClick={() => handleScroll("milestones")}>Achievements</li>
            <li onClick={() => handleScroll("contact")}>Contact</li>

            {/* PAGE LINKS */}
            <li>
              <Link to="/gallery" className="nav-link" onClick={() => setOpen(false)}>
                Gallery
              </Link>
            </li>

            <li>
              <Link to="/blogs" className="nav-link" onClick={() => setOpen(false)}>
                Blog
              </Link>
            </li>

          </ul>

          {/* MOBILE MENU */}
          <div className="menu-icon" onClick={() => setOpen(!open)}>
            ☰
          </div>

        </div>

      </div>
    </nav>
  );
}